import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import Root from './root.component';
import { init as initApm } from '@elastic/apm-rum';
import FallbackPage from './pages/Error/Fallback.component';

var pageName = window.location.href;

var apm = initApm({
    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: 'uhc-fpc-price-care-services_aide_0077425',

    // TODO: if this works in dev, update serverUrl and environment to be parameterized by env
    serverUrl: 'https://eapm-gw-nonprod.uhc.com:443',
    environment: `Microfrontend-${process.env.ENV}`,
    pageLoadTransactionName: pageName,

    distributedTracingOrigins: [
        'https://estimatesdev.uhc.com/#/login',
        'https://estimatesdev.uhc.com/#/search',
        'https://estimatesdev.uhc.com/#/estimate',
    ],

    //span tracing
    pageLoadTraceId: '${transaction.traceId}',
    pageLoadSpanId: '${transaction.ensureParentId()}',
    pageLoadSampled: true,

    propagateTracestate: true, // Optional: to propagate tracestate header
    globalLabels: 'com_uhg_appid=aide_0077425',
    logLevel: 'debug',
    active: 'true',
    instrument: 'true',
    capturePageLoad: true,
    captureHistory: true, // Ensure this is set to true
});

const lifecycles = singleSpaReact({
    React,
    ReactDOM,
    rootComponent: Root,
    errorBoundary(err, info, props) {
        // Customize the root error boundary for your microfrontend here.
        return <FallbackPage />;
    },
});

export const { bootstrap, mount, unmount } = lifecycles;
